__turbopack_context__.v({
  "chip": "lh7Mta_chip",
  "icon": "lh7Mta_icon",
  "inverse": "lh7Mta_inverse",
  "remove": "lh7Mta_remove",
  "selected": "lh7Mta_selected",
  "unselected": "lh7Mta_unselected",
});
